import React from 'react';

import { Button } from '@rbilabs/components-library';

import { ISanityImage } from '@rbi-ctg/menu';
import { IImageFragment } from 'generated/sanity-graphql';

import {
  StyledBody,
  StyledDialog,
  StyledHeader,
  StyledPicture,
} from './short-code-confirmation-modal.styled';

interface IShortCodeConfirmationModal {
  actionText: string;
  bodyText?: string;
  handleAction: () => void;
  headerText: string;
  image: ISanityImage | IImageFragment;
}

const ShortCodeConfirmationModalView = ({
  actionText,
  bodyText,
  handleAction,
  headerText,
  image,
}: IShortCodeConfirmationModal) => {
  const Header = () => <StyledHeader>{headerText}</StyledHeader>;
  const Body = () => <StyledBody>{bodyText}</StyledBody>;
  const Actions = () => (
    <Button data-testid="short-code-confirmation-action" onClick={handleAction}>
      {actionText}
    </Button>
  );

  return (
    <StyledDialog
      data-testid="short-code-confirmation-modal"
      headingComponent={<Header />}
      image={<StyledPicture image={image} alt="short-code-confirmation" />}
      bodyComponent={<Body />}
      actions={<Actions />}
      modalAppearanceEventMessage="Loyalty Shortcode Confirmation Modal"
    />
  );
};

export default ShortCodeConfirmationModalView;
